/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { Grid, TextField, Autocomplete } from '@mui/material';
import { styled } from '@mui/material/styles';

import './styles.css';
import Loader from '../../Lottifiers/Loader/Loader';

interface ICustomAutoCompleteProps {
  label?: string;
  value?: any;
  defaultValue?: any;
  onChange?: any;
  options?: any;
  freeSolo?: boolean;
  clearOnBlur?: boolean;
  customWidth?: any;
  customHeight?: any;
  getOptionLabel?: any;
  size?: 'small' | 'medium';
  required?: boolean;
  isLoading?: boolean;
  errors?: ReactNode;
  disable?: any;
  helperText?: string;
}

const StyledAutoComplete = styled(Autocomplete)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E6E8F0',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#E6E8F0',
  },
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#7C0E6F',
  },
  '& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
    fontSize: '0.85em',
    fontFamily: 'Lato',
  },
  '& label.Mui-focused': {
    color: '#7C0E6F',
  },
  '& .css-nxo287-MuiInputBase-input-MuiOutlinedInput-input': {
    fontSize: '0.85em',
    fontFamily: 'Lato',
  },
});
const CustomAutoComplete = ({
  options = [],
  label,
  onChange,
  value,
  defaultValue,
  freeSolo = false,
  clearOnBlur = false,
  customWidth = '100%',
  customHeight,
  getOptionLabel,
  size,
  required = true,
  isLoading,
  errors,
  disable = false,
  helperText
}: ICustomAutoCompleteProps) => {
  return (
    <Grid
      item
      xs={12}
      style={{
        position: 'relative',
      }}
    >
      <StyledAutoComplete
        renderInput={(params) => (
          <TextField
            required={required}
            {...params}
            label={label}
            style={{
              width: customWidth,
              height: customHeight,
            }}
            error={Boolean(errors)}
            helperText={errors}
          />
        )}
        size={size}
        options={options}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        freeSolo={freeSolo}
        clearOnBlur={clearOnBlur}
        getOptionLabel={getOptionLabel}
        disabled={disable}
      />
      {helperText && (<p style={{ color: '#6b7280', fontSize: '12px', marginTop: '4px' }}>{helperText}</p>)}
      {isLoading ? (
        <div className="loader">
          <Loader height={60} width={60} />
        </div>
      ) : null}
    </Grid>
  );
};

export default CustomAutoComplete;
